// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAmdXfAVp0maHbA_B4ubsZP20wJct9B3FA",
  authDomain: "wilson-tradings.firebaseapp.com",
  projectId: "wilson-tradings",
  storageBucket: "wilson-tradings.firebasestorage.app",
  messagingSenderId: "580516213057",
  appId: "1:580516213057:web:4ba9715c8ad7d8db5eb1c0",
  measurementId: "G-3BX4F0C804"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);